<app-filters-sidebar-filter [label]="label()">
  <header>{{label()}}</header>

  @if (searchable()) {
    <div class="mb-2">
      <app-search label="{{label()}} Search" [(value)]="search"></app-search>
    </div>
  }

  @for(option of options(); track $index) {
    <div [class.max-h-0]="$index > 2 && hideLinks()"
         [class.opacity-0]="$index > 2 && hideLinks()"
         [class.overflow-hidden]="$index > 2 && hideLinks()"
         [class.max-h-20]="$index <= 2 || !hideLinks()"
         [class.opacity-100]="$index <= 2 || !hideLinks()"
         [class.mb-2]="$index <= 2 || !hideLinks()"
         class="transition-all duration-500 ease-in-out mx-2 line-clamp-1">
      <app-checkbox [title]="option.label" [label]="option.label" [checked]="isChecked(option.value)" (valueChange)="checkChanged(option.value, $event)" class=""/>
    </div>
  } @empty {
    <span class="text-sm ">No Filters Found</span>
  }

  @if (options().length > 3) {
    <app-link class="text-sm relative overflow-hidden ms-2" (click)="hideLinks.set(!hideLinks())">
      <span class="inline-flex items-center gap-1 whitespace-nowrap">
        <span [class.opacity-0]="!hideLinks()" [class.opacity-100]="hideLinks()" class="transition-opacity duration-300 ease-in-out absolute">
          Show More <app-icons icon="arrow-right"></app-icons>
        </span>

        <span [class.opacity-0]="hideLinks()" [class.opacity-100]="!hideLinks()" class="transition-opacity duration-300 ease-in-out">
          Show Less <app-icons icon="arrow-up"></app-icons>
        </span>
      </span>
    </app-link>
  }
</app-filters-sidebar-filter>
